import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getNewsAndGuidesDetailsPageData } from './api';
import type { NewsAndGuidesDetailsPageDataErrorCode } from './types';

export const {
	Context: NewsAndGuidesDetailsPageDataContext,
	Provider: NewsAndGuidesDetailsPageDataContextProvider,
	useContext: useNewsAndGuidesDetailsPageData,
	useAsyncData: useNewsAndGuidesDetailsPageDataFromApi,
	prefetchAsyncData: prefetchNewsAndGuidesDetailsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'NewsAndGuidesDetailsPageDataContext',
	dataProperty: 'pageData',
	getData: getNewsAndGuidesDetailsPageData,
	hookDeps: ({ countryCode, locale, slug, disableMode }) => [countryCode, locale, slug, disableMode],
	getUniqueId: ({ countryCode, locale, slug, disableMode }) => [countryCode, locale, slug, disableMode].join('|'),
	errorHandler: pageDataErrorHandler<NewsAndGuidesDetailsPageDataErrorCode>(),
});
